import AssessmentPagesFooter from "@/components/AssessmentPagesFooter";
import AssessmentSideBar from "@/components/AssessmentSideBar";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AssessmentHighlights = () => {
	const navigate = useNavigate();
	const rawData = sessionStorage.getItem("question");
	let data: {
		Behaviour_q?: object;
		tech_questions?: object;
		coding_question?: object;
		coding_language?: string;
	} = {};

	try {
		data = rawData ? JSON.parse(rawData) : {};
	} catch (error) {
		console.error("Failed to parse sessionStorage 'question':", error);
	}

	const behavioralQuestions = data?.Behaviour_q
		? Object.keys(data.Behaviour_q).length
		: 0;
	const technicalQuestions = data?.tech_questions
		? Object.keys(data.tech_questions).length
		: 0;
	const codingQuestions = data?.coding_question
		? Object.keys(data.coding_question).length
		: 0;
	const currentAssessmentSection = sessionStorage.getItem("assessmentSection");

	useEffect(() => {
		if (!codingQuestions) {
			if (!behavioralQuestions && !technicalQuestions) {
				navigate("/feedback-form");
				return;
			}
		}

		setTimeout(() => {
			if (currentAssessmentSection === "behavioural") navigate("/test");
			else if (currentAssessmentSection === "technical") navigate("/mcq-main");
			else navigate("/code");
		}, 5000);
	}, []);

	return (
		<>
			<div className="min-h-[90vh]">
				<AssessmentSideBar></AssessmentSideBar>
				<div className="my-8 ">
					<div className="text-center mb-6">
						<h2 className="text-3xl font-bold">Assessment Summary</h2>
					</div>

					<div className="flex gap-16 mt-32 justify-center items-center">
						{behavioralQuestions !== 0 && (
							<div
								className={` rounded-lg p-5 bg-white w-full max-w-sm text-center ${
									currentAssessmentSection === "behavioural"
										? "shadow-[0px_0px_41px_3px_#B3E0BA]"
										: "shadow-lg"
								}`}
							>
								<h3 className="text-xl font-semibold mb-2">
									Behavioral Assessment
								</h3>
								<p className="text-gray-600 mb-1">
									{behavioralQuestions} Questions - {behavioralQuestions * 2}{" "}
									Minutes
								</p>
								<p className="text-sm text-gray-500">Audio Assessment</p>
							</div>
						)}

						{technicalQuestions !== 0 && (
							<div
								className={`rounded-lg p-5 bg-white w-full max-w-sm text-center ${
									currentAssessmentSection === "technical"
										? "shadow-[0px_0px_41px_3px_#B3E0BA]"
										: "shadow-lg"
								}`}
							>
								<h3 className="text-xl font-semibold mb-2">
									Technical Assessment
								</h3>
								<p className="text-gray-600 mb-1">
									{technicalQuestions} Questions - {technicalQuestions * 1}{" "}
									Minutes
								</p>
								<p className="text-sm text-gray-500">MCQ Questions</p>
							</div>
						)}

						{codingQuestions !== 0 && (
							<div
								className={` rounded-lg p-5 bg-white w-full max-w-sm text-center ${
									currentAssessmentSection === "coding"
										? "shadow-[0px_0px_41px_3px_#B3E0BA]"
										: "shadow-lg"
								}`}
							>
								<h3 className="text-xl font-semibold mb-2">
									Coding Assessment
								</h3>
								<p className="text-gray-600 mb-1">
									{codingQuestions} Questions - {codingQuestions * 15} Minutes
								</p>
								<p className="text-sm text-gray-500">{data?.coding_language}</p>
							</div>
						)}
					</div>
				</div>
			</div>
			<AssessmentPagesFooter />
		</>
	);
};

export default AssessmentHighlights;
